<template>
	<p class="note"><slot /></p>
</template>

<script>
export default {
	name: 'Note',
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.note {
	font-size: 0.875rem;
	font-style: italic;
	color: $grey-32;
}
</style>
